<template>
  <div>
    <v-data-table
      dense
      :headers='headers'
      :items='estimates'
      :search='search'
      :loading='isLoading'
      :items-per-page='20'
      multi-sort
      @click:row='openEstimate'
    >
      <template v-slot:item.name='{ item }'>
        <span class='black--text'>{{ item.name }}</span>
        <div class='grey--text' style='margin-top: -7px; margin-bottom: -2px;'><small>{{ item.number }}</small>
          <v-icon v-if='item.is_comm' class='mt-n1' right small color='primary'>mdi-domain</v-icon>
          <wc-archived v-if='item.archived'></wc-archived>
        </div>
      </template>
      <template v-slot:item.estimate_date='{ item }'>
        {{ item.estimate_date | shortDate }}
      </template>
      <template v-slot:item.site_address='{ item }'>
        <!-- <span v-if='item.project_obj'>{{ item.project_obj.site_address }}</span> -->
        <!-- <span v-else>{{ item.site_address }}</span> -->
        <span>{{ item.site_address }}</span>
        
        <div class='grey--text' style='margin-top: -7px; margin-bottom: -1px;'>
          <!-- <small v-if='item.project_obj'>{{ item.project_obj.site_city }}</small> -->
          <!-- <small v-else>{{ item.site_city }}</small> -->
          <small>{{ item.site_city }}</small>
        </div>
      </template>
      <template v-slot:item.estimate_type='{ item }'>
        <wc-estimate-type right :estimate='item' v-if="item.division_obj.division_type === 'I'" xSmall></wc-estimate-type>
      </template>
      <template v-slot:item.status='{ item }'>
        <wc-estimate-status :estimate='item' xSmall showTooltip></wc-estimate-status>
      </template>
      <template v-slot:item.division_obj.division='{ item }'>
        <wc-division-nai :division_obj='item.division_obj'></wc-division-nai>
      </template>
      <template v-slot:item.estimator_obj.name_display='{ item }'>
        <!-- <wc-avatar :profile='item.estimator_obj'></wc-avatar> -->
        {{ item.estimator_obj.first_name}}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import WCEstimateStatus from '@/components/chips/WCEstimateStatus'
import WCEstimateType from '@/components/chips/WCEstimateType'

export default {
  name: 'estimates-table',
  props: {
    estimates: {
      // estimates should be pre-ordered in the desired initial display order before being loaded into this component
      // (so that the user doesn't have to un-choose a pre-selected filter arrow in order to use/select others) - MJ
      required: true
    },
    isLoading: {
      required: true
    },
    search: {
      required: true
    }
  },
  data: () => ({
    headers: [
      { text: 'Date', value: 'estimate_date', width: '120' },
      { text: 'Division', value: 'division_obj.division', width: '120' },
      { text: 'Number', value: 'number', align: ' d-none' },
      { text: 'Name', value: 'name' },
      { text: 'Site Address', value: 'site_address' },
      { text: 'Site City', value: 'site_city', align: ' d-none' },
      { text: 'Type', value: 'estimate_type', align: 'center' },
      { text: 'Status', value: 'status', align: 'center' },
      { text: 'Estimator', value: 'estimator_obj.name_display', align: 'start', width: '110' }
    ]
  }),
  methods: {
    openEstimate (est) {
      this.$router.push({ name: est.division_obj.division + 'Estimate', params: { id: est.id } })
      // this command requires Division Specific Estimate Detail Pages to have a common naming convention (which they should/will)
    },
  },
  components: {
    'wc-estimate-type': WCEstimateType,
    'wc-estimate-status': WCEstimateStatus,
  }
}
</script>